export class Services {

    static #instances = new Map();

    static register(name, instance) {

        if (this.#instances.has(name)) {
            throw new Error(`Service [${name.toString()}] už je zaregistrovaná!`);
        }

        this.#instances.set(name, instance);

    }

    static get(name) {

        let service = this.#instances.get(name);

        if (!service) {
            throw new Error(`Service [${name.toString()}] nebyla nalezena! Registrace pravděpodobně selhala nebo neproběhla.`);
        }

        if (typeof service === 'function') {
            // První volání: funkci spustíme, instanci uložíme a příště už vracíme hotovou věc
            service = service();
            this.#instances.set(name, service);
        }

        return service;

    }

    // TIPS
    // Asynchronní inicializace, lazy loadingin (deferred inicializace?)... To je najednou nápadů!

}
